const MULTIVALUE_JSON_PAIRS = [
  {
    attributeCode: 'numberOfKiosk',
    appearsInMultivalueJsonFor: 'digitalKioskType',
    isValidatedOnSubmit: true,
  },
];

const multivalueJsonObject = MULTIVALUE_JSON_PAIRS.reduce((acc, { attributeCode, appearsInMultivalueJsonFor, isValidatedOnSubmit }) => ({ ...acc, [attributeCode]: { appearsInMultivalueJsonFor, isValidatedOnSubmit } }), {});
const referentAttributesObject = MULTIVALUE_JSON_PAIRS.reduce((acc, { appearsInMultivalueJsonFor, attributeCode }) => ({ ...acc, [appearsInMultivalueJsonFor]: attributeCode }), {});

export function getIsHandledByMultivalueJson(code) {
  return !!multivalueJsonObject[code];
}

export function getIsValidatedOnSubmit(code) {
  return !!multivalueJsonObject[code]?.isValidatedOnSubmit;
}

export function getReferentAttributeCode(code) {
  return referentAttributesObject[code];
}

